import { actions$ } from "mini-rx-store";
import { catchError, map, of, switchMap } from "rxjs";
import { ofType } from "ts-action-operators";

import { loadParteiSicht } from "./parteien-actions.js";
import { parteienService } from "../service/parteien-service.js";

export const loadParteiSichtEffect = actions$.pipe(
  ofType(loadParteiSicht.action),
  switchMap(({ payload: slug }) =>
    parteienService.ladeSicht(slug).pipe(
      map((s) => loadParteiSicht.success(s)),
      catchError((err) => of(loadParteiSicht.fail(err))),
    ),
  ),
);

export const parteienEffects = [loadParteiSichtEffect];
